const React = require("react")
const { LogoAlgar } = require("./icons/logo-algar")
const { UserGuide } = require("./icons/user-guide")
const { QrcodeApp } = require("./icons/qrcode-app")
const { LogoClubeAlgar } = require("./icons/clubeAlgarSempre")

module.exports = {
  LogoAlgar: (props) => <LogoAlgar alt="Algar logo" {...props} />,
  UserGuide: (props) => <UserGuide alt="Manual do usuário" {...props} />,
  QrcodeApp: (props) => <QrcodeApp alt="QR Code" {...props} />,
  LogoClubeAlgar: (props) => <LogoClubeAlgar alt="Logo Algar" {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/banner/index.js